import { SET_USER_INFO } from "../actions/Types";

const initialState = {
  permissions: [],
  token: "",
};

const UserInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      const info = action.payload;
      // console.log("info: ", info);
      return info;
    // return { ...state, permissions: info.permissions, token: info.token };
    default:
      return state;
  }
};

export default UserInfoReducer;
